/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { InputNumber  } from 'primereact/inputnumber';
import TableElement from './atom/Table';
import { SeuilsApi } from '../../utils/api';
import { Toast } from 'primereact/toast';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import AutocompleteComponent from './atom/AutoComplete';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import ModernDatePicker from '../../components/common/component/ModernDatePicker';
import { inputTextDate } from '../../utils/helpers/view/detailsHelper';
import { dateFr, loaderDataComponent } from '../../utils/helper';
import ErrorParameter from '../../components/common/ErrorParameter';
declare type flowProps = {
  id?: string;
  token: string;
  mainInstallCode: string;
};

const FormFlow = ({ mainInstallCode }: flowProps) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [measureDate, setMesureDate] = useState(null);
  const [pumps, setPumps] = useState<any>();
  const [value, setValue] = useState(0);
  const [pump, setPump] = useState<any>({});
  const toast = useRef<any>(null);

  // Show toast function
  const ShowToast = (severity: any, summary: any, detail: any) => {
    return toast.current?.show({
      severity: severity,
      summary: summary,
      detail: detail,
      life: 5000,
    });
  };

  // get Pumps parameter function
  const getPumpParam = async () => {
    setLoading(true);
    try {
      const response = await SeuilsApi.getPumpParameters(mainInstallCode);
      setPumps([
        ...response.data.pumpsToConfigureList,
        ...response.data.configuredPumpsList,
      ]);
      if (response.status === 200 && response.data.length < 1) {
        ShowToast(
          'error',
          'Erreur',
          'Nous ne pouvons pas afficher la donnée car elle est inexistante',
        );
      }
      if (
        response.data.pumpsToConfigureList.length < 1 &&
        response.data.configuredPumpsList.length < 1
      ) {
        setError(true);
      }
    } catch (e) {
      setError(true);
      ShowToast(
        'error',
        'Erreur',
        'Erreur lors de la récuperation des données de paramètres',
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPumpParam();
  }, []);

  // handle On Submit function
  const handleOnSubmit = async () => {
    setLoading(true);
    try {
      const { name, ...rest } = pump;
      const param = { ...rest, value, date: inputTextDate(measureDate), source: pump.source };
      const response = await SeuilsApi.updatePumpParameters(param);
      setPump(response.data);
      if (response.status === 200) {
        getPumpParam();
        ShowToast('success', 'Succès', 'Données de paramètres modifiés');
      }
    } catch (e) {
      ShowToast(
        'error',
        'Erreur',
        "Erreur lors de l'enregistrement des données de paramètres",
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container
      automatedTestId='form-flow-global-container'
      className='form-flow-global-container sds-reset-style'
    >
      <Styles />
      <Toast ref={toast} />
      {pumps && Object.keys(pumps).length > 0 && (
        <Container className='form-flow-global-content'>
          <Container className='flow-blocs'>
            <Container className='pompe-param'>
              <Word
                variant='p'
                textStyle='normalReg'
                value='Pompe à paramétrer'
                className='number-title'
              />
              <AutocompleteComponent
                id='filtre-pompe'
                Listoption={pumps.map((value: any) => {
                  return { ...value, name: `${value.variableName} - ${value.source}`, };
                })}
                onChangeValue={(event: any, pump: any) => setPump(pump)}
                getOptionValue={(option: any) => option.name}
                getOptionSelected={(option: any, value: any) =>
                  option.id === value.id
                }
              />
            </Container>
            <Container className='pompe-date'>
              <Word
                variant='p'
                textStyle='normalReg'
                value='Date de la mesure'
                className='number-title'
              />
              <ModernDatePicker
                className='datePickFrom'
                inputPlaceholder='Date de la mesure'
                value={ measureDate}
                shouldHighlightWeekends
                formatInputText={() => {
                  return inputTextDate(measureDate);
                }}
                locale={dateFr}
                onChange={(date: any) => {
                  setMesureDate(date);
                }}
              />
            </Container>
            <Container className='pompe-value'>
              <Word
                variant='p'
                textStyle='normalReg'
                value='Valeur de Débit (m³/h)'
                className='number-title'
              />
              <InputNumber
                className='flow-input'
                id='flow-input'
                value={value}
                onValueChange={(v: any) => setValue(v.target.value)}
                mode='decimal'
                minFractionDigits={4}
              />
            </Container>
          </Container>
          <Container className='pompe-table'>
            <TableElement
              arr={pumps}
              mainInstallCode={mainInstallCode}
              setPumps={setPumps}
              setLoading={setLoading}
            />
          </Container>
          <Container className='submitButton'>
            {loading === false && <StyledSectionButton>
              <Button
                automatedTestId='btn-flow-validation'
                className='param-btn'
                mode='plain'
                onClick={handleOnSubmit}
              >
                <Word variant='span' textStyle='normalBold' value='Valider' />
              </Button>
            </StyledSectionButton>}
          </Container>
        </Container>
      )}
      {loaderDataComponent(loading)}
      {error && (
        <ErrorParameter
          message="une erreur s'est produite. Veuillez réessayer"
          title=''
          IsVisible={true}
        />
      )}
    </Container>
  );
}

const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
  .param-btn {
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    margin-bottom: 15px;
  }
`;
const Styles = createGlobalStyle`
.form-flow-global-container.sds-reset-style{ 
.form-flow-global-content{
  .sds-reset-style .autocomplete .input
  {
    width: 275px;
  }
  .pompe-table{
    table, th, td {
      text-align: center;
      width: 600px;
      height: 30px;
      border: 2px solid rgb(237, 242, 250);
    }
  }
  .flow-blocs{
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-bottom: 20px;
    .pompe-value {
      .flow-input input{
            background-color: rgb(255, 255, 255);
            border: 1px solid rgb(204, 232, 246);
            border-radius: 5px;
            width: 95px;
            height: 55px;
            text-align: center;
      }
    }
    .pompe-param {
      width: 300px;
    }
  }
  .pompe-table {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
  .submitButton{
    margin-bottom: 20px;
  }
}
}
`;

export default FormFlow;
